import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import Tab from 'react-bootstrap/Tab';
export const TabContent = ({ tabs }) => {
    const renderTabs = useMemo(() => tabs.map((tab) => (_jsx(Tab.Pane, Object.assign({ eventKey: tab.eventKey }, { children: tab.content }), tab.eventKey))), [tabs]);
    return _jsx(Tab.Content, { children: renderTabs });
};
